export default {
    title: (mode, type) => `${mode} cost estimate by invoice - ${type}`,
    FromDate: 'From Date',
	ToDate: 'To date',
	Quota: 'Quota',
	AddCostType: 'Add cost norms',
	EditCostType: 'Edit cost norms',
	PlaceholderNormsAccordingToInvoice: 'Enter the amount',
	WarningUpdateCostTypeInvoices:'The program only performs cost rate updates for invoices that are classified as cost and not for discounted/cancelled/replaced invoices.',
	MaxNumberDetailNorms: 'Cannot add because the program only meets the 20 line quota.',
	ListClassificationInvoiceDetailEmpty: type =>
		`There are no established norms for cost type ${type}. Do you want to save?`,
	UpdateClassificationInvoiceDetailWarning: href =>
		`<div>Invoices entered into the program will not automatically update to new cost norms. You need to click Update cost norms for old invoices. <a href=${href} target="_blank">See the instructions</a></div>`,
	UpdateCostTypeInvoiceByTimeTitle : (mode, name) => `${mode} cost norms by time - ${name}`,
	ChangePeriodWarning: (oldPeriod, newPeriod, costName) => `The rows of norms according to ${oldPeriod} will be deleted when changing the period from ${oldPeriod} to ${newPeriod}. Are you sure you want to edit the norm period for the cost type ${costName}?`,
}